import React from 'react'

const ErrorMessage = (props) => {
	let { message } = props
	if(!message || message.trim().length === 0) {
		return (
			<span></span>
		)
	} else {
		return <span className='error'>{message}</span>
	}
}

export { ErrorMessage } 


// WEBPACK FOOTER //
// ./src/containers/AdMonitorHome/ErrorMessage.js